import { render, staticRenderFns } from "./RenewalOverview.vue?vue&type=template&id=5ceafadb&"
import script from "./RenewalOverview.vue?vue&type=script&lang=js&"
export * from "./RenewalOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports